exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "article[data-v-332f3e2d]{position:relative;padding:30px;padding-top:0;background-color:var(--background-color);color:var(--text-color);--tab-padding:30px}.content-wrapper[data-v-332f3e2d]{max-width:var(--max-cont-w);width:100%}.tabList[data-v-332f3e2d]{grid-column:7/span 6;list-style:none;margin-bottom:0;margin-top:0;padding:0;text-align:left}li[data-v-332f3e2d]{cursor:pointer}.leftBleed[data-v-332f3e2d]{grid-column:1/7}.pointerCursor[data-v-332f3e2d]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-332f3e2d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/VideoToggle.vue
// module id = SUXM
// module chunks = 4